<template>
    <div class="popup-color-component">
        <div class="popup-color-component__content">
            <div class="popup-color-component__content-icon">
                <svg width="57" height="56" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_d)">
                    <ellipse cx="28.5" cy="24" rx="24.5" ry="24" fill="url(#paint0_linear)"/>
                    <path d="M26 11.7549L26.5 28.4079H30.5L31 11.7549H26Z" fill="#3C3A36"/>
                    <ellipse cx="28.5" cy="32.8162" rx="2.5" ry="2.44898" fill="#3C3A36"/>
                    </g>
                    <defs>
                    <filter id="filter0_d" x="0" y="0" width="57" height="56" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                    <feOffset dy="4"/>
                    <feGaussianBlur stdDeviation="2"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
                    </filter>
                    <linearGradient id="paint0_linear" x1="4" y1="24.9796" x2="53" y2="24.9796" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#FFE24B"/>
                    <stop offset="1" stop-color="#E9C031"/>
                    </linearGradient>
                    </defs>
                </svg>
            </div>

            <header>
              <slot name="header"></slot>
            </header>
            <div class="popup-color-component__content-text" v-if="!is_slot">

                {{ text }}
                <br><br>
                {{ hint }}
            </div>
            <div class="popup-color-component__content-button"
                @click="clickButton()"
            >
                <span>ok</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            text: {
                default: ''
            },
            hint: {
                default: ''
            },
            is_slot: {
              default: false
            }
        },
        methods: {
            async clickButton() {
                this.$emit('clickButton')
            }
        }
    }
</script>

<style lang="less">
    .popup-color-component {
        width: 100vw;
        height: 100vh;
        min-height: 430px;
        overflow: auto;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        z-index: 10;
    }

    .popup-color-component__content {
        max-width: 343px;
        width: 100%;
        background:  linear-gradient(90deg, #D85931 0%, #D52E2E 100%);
        border-radius: 13px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px;
    }

    @import '~/assets/fonts/roboto/Roboto-Light.less';

    .popup-color-component__content-text {
        margin-top: 15px;
        color: #FFFFFF;
        text-align: center;
        font-size: 15px;
        line-height: 20px;
        font-family: 'Roboto-Light';
    }

    @import '~/assets/fonts/montserrat/Montserrat-Medium.less';

    .popup-color-component__content-button {
        background-color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        text-transform: uppercase;
        font-family: 'Montserrat-Medium';
        width: 95%;
        height: 44px;
        border-radius: 5px;
        margin-top: 20px;
        cursor: pointer;
    }
</style>